import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Menu from '../../../../common/menu/menu';
import MenuItem from '../../../../common/menu/menu-item/menu-item';
import { SORTING_OPTIONS } from '../../../../../helpers/sort-helper';

import './SortOptions.scss';

const SortOptions = ({
    changeSelectedSort,
    selectedSort
}) => {
    const onSortSelect = sort => () => changeSelectedSort(sort);
    const [selectedSortOption, setSelectedSort] = useState(SORTING_OPTIONS.find(sort => sort.value === selectedSort));

    useEffect(() => {
        setSelectedSort(SORTING_OPTIONS.find(sort => sort.value === selectedSort));
    }, [selectedSort]);

    const getClassName = (value) => {
        if (value === selectedSort) {
            return 'selected';
        }
        return null;
    };

    const renderMenuItems = () => {
        const selectedSortMenuItem = (
            <MenuItem
                key="current-sort"
                preventMenuClose
            >
                <span className="text-bold">
                    {`Sorted by: ${selectedSortOption.labelPrefix} (${selectedSortOption.label})`}
                </span>
            </MenuItem>
        );
        const menuItemOptions = SORTING_OPTIONS.map(({ label, labelPrefix, value }) => (
            <MenuItem
                key={value}
                onClick={onSortSelect(value)}
                preventMenuClose
                className={getClassName(value)}
            >
                {`${labelPrefix} (${label})`}
            </MenuItem>
        ));
        return [selectedSortMenuItem, ...menuItemOptions];
    };

    return (
        <div className="glu-flex-shrink glu-sort-options">
            <Menu
                menuIcon="sorting"
                tooltipLabel="Sort"
                customClass="glu-sort-options-menu"
            >
                {renderMenuItems()}
            </Menu>
        </div>
    );
};

SortOptions.propTypes = {
    changeSelectedSort: PropTypes.func,
    selectedSort: PropTypes.string
};

SortOptions.defaultProps = {
    changeSelectedSort: undefined,
    selectedSort: ''
};

export default SortOptions;
